var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.499,
    height: 19.499,
    viewBox: "0 0 19.499 19.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard",
    d: "M4.5,15.1h8V4.5h-8Zm0,7.4h8v-4.6h-8Zm10,0h8V12.308h-8Zm0-18V9.115h8V4.5Z",
    transform: "translate(-3.75 -3.75)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassdashboard);
export default __webpack_public_path__ + "static/media/Classdashboard.6580ca4aa7ebc54e60dfee507fc735b3.svg";
export { ForwardRef as ReactComponent };